export default {
  auth: {
    login: "Login",
    email: "Email",
    password: "Password",
    confirm_password: "Confirm password",
    signup: "Sign Up",
    staff_signup: "Staff sign up",
    forget_password: "Forget password?",
    domain_access_denied: "This account cannot be used from this domain.",
    account_locked: "Your account has been temporarily suspended. Please contact the administrator.",
    company_name: "Company name",
    company_address: "Company address",
    company_country: "Country",
    tax_id: "Tax ID",
    contact_person: "Contact Person",
    contact_person_title: "Title",
    contact_person_firstname: "Firstname",
    contact_person_lastname: "Lastname",
    tel: "Tel",
    bank_detail: "Banking detail",
    bank_description: "Your banking details will be shown in your customer invoice",
    bank_name: "Bank name (Optional)",
    account_number: "Account number (Optional)",
    account_name: "Account name (Optional)",
    company_logo: "Upload company logo",
    promptpay_qr: "Upload Promptpay QR",
    optional: "(Optional)",
    signup_submitted_title: "Sign up request submittted",
    signup_submitted_content: "Our staff will contact you to verify your qualification within 24 hours",
    staff_signup_success: "Sign up was successful",
    forgot_password: {
      title: "Reset password",
      enter_email_reset_password: "Enter email to reset the password",
      next: "Next",
      success: "Please check your email",
      back_to_login: "Back to Login",
    },
    two_factor: {
      signing_in_as: "Signing in as {email}",
      setup_for: "Setting up 2FA for {email}",
      back_to_login: "Back to login",
      skip: "Skip 2FA",
    },
    reset_password: {
      title: "Reset password",
      enter_new_password: "Enter new password",
      confirm_new_password: "Confirm new password",
      reset: "Reset",
      success: "Reset password was successful",
    },
    change_password: {
      title: "Change password",
      current_password: "Current password",
      new_password: "New password",
      confirm_new_password: "Confirm new password",
      submit: "Save Change",
      success: "Change password was successful",
    },
    ok: "OK",
    next: "Next",
  },
  menu: {
    change_password: "Change password",
    logout: "Logout",
    cruise_search: "Cruise search",
    dashboard: "Dashboard",
    agent_account: "Org. Management",
    booking: "Booking",
    my_booking: "My Booking",
    my_company: "My Company",
    commission: "Commission",
    org_hierarchy: "Network Management",
  },
  manage: {
    agent_account: {
      title: "My agent's account",
      export: "Export",
      invite: "Invite",
      invitation_pending_list: "Invitation Pending List",
      invitee: "Invitee",
      invitee_email: "Email",
      invited_date: "Invited Date",
      manage: "Manage",
      headers: {
        agent_id: "Agent ID",
        agent_company_name: "Agent company name",
        register_date: "Regis. date",
        last_login: "Last login",
        last_12_months_dollar: "Last 12 mo. ($)",
        last_12_months_pax: "Last 12 mo. (pax)",
        status: "Status",
      },
      item: {
        view_mode: "View mode",
        edit_mode: "Edit mode",
        company_name: "Company name",
        company_address: "Company address",
        company_country: "Country",
        tax_id: "Tax ID",
        contact_person: "Contact Person",
        contact_person_title: "Title",
        contact_person_firstname: "Firstname",
        contact_person_lastname: "Lastname",
        tel: "Tel",
        bank_detail: "Banking detail",
        bank_description: "Your bank account for receiving the payment from your client",
        bank_name: "Bank name",
        account_number: "Account number",
        account_name: "Account name",
        config_detail: "My configuration",
        terms_and_condition_quotation: "Terms & Condition for Quotation",
        terms_and_condition_invoice: "Terms & Condition for Invoice",
        max_number_reserved_cabins: "Max. number of reserved cabin",
        commission_rate: "Commission Rate",
        local_currency: "Local Currency",
        suspended: "Suspended",
        upload_company_logo: "Upload company logo",
        upload_promptpay_qr: "Upload Promptpay QR",
        company_logo: "Company logo",
        promptpay_qr: "Promptpay QR",
        show_users_by_status: "Show Users By Status",
        agent_admin_email: "Email",
        agent_admin_status: "Status",
        add_new_user: "Add new user",
        invite: "Invite",
        edit_user: "Edit User",
        back: "Back",
        cancel: "Cancel",
        edit: "Edit",
        save_change: "Save change",
        approve: "Approve",
        reject: "Reject",
        approve_user_confirm_message: "Are you sure you want to approve this company?",
        reject_user_confirm_message: "Are you sure you want to reject this company?",
        remove_user_confirm_message: "Are you sure you want to remove this user?",
        maker_invitee_confirm_message: "Are you sure you want to invite this email for a new agent maker?",
        save_changes_success: "Save changes was successful",
        org_relationship: "Organization Relationship",
        org_relationship_description: "Parent-child hierarchy of this organization",
        parent_org: "Parent Organization",
        no_parent: "No parent organization",
        children_orgs: "Child Organizations",
        no_children: "No child organizations",
        allowed_login_domains: "Allowed login domains (organization)",
        allowed_login_domains_hint:
          "Applies to all users in this organization. Leave empty to inherit from parent or allow all domains.",
        allowed_login_domains_inherited:
          "Effective domains inherited from {name} (#{id}). Set values below to override for this organization only.",
        allowed_login_domains_all: "All domains",
      },
    },
    booking: {
      title: "My agent's booking",
      platform: "Platform",
      search: "Search",
      export: "Export",
      manage: "Manage",
      change_owner: "Change Owner",
      export_coming_soon: "Export will be available soon",
      filter: {
        date_field: "Date filter field",
        date_field_sailDate: "Departure date",
        date_field_refDate: "Reservation date",
        from: "From",
        to: "To",
        keyword_field: "Search by",
        keyword_field_default: "Booking info (multiple columns)",
        keyword_field_agent_company_name: "Agent company name",
        search_any_keyword: "Search any keyword",
        select_all: "Select all",
        clear: "Clear",
        status: "Status",
        reservation_status: "Reservation Status",
      },
      headers: {
        reservation_date: "Reservation\ndate",
        grouping_id: "Grouping\nID",
        reservation_id: "Res.\nID",
        departure_date: "Departure\nDate",
        ship: "Ship",
        agent_company_name: "Agent company\nname",
        record_source: "Record\nsource",
        confirmation_status: "Confirmation Status",
        total_amount: "Total\namount",
        next_due: "Next due\n18:00 (UTC+07)\nThailand time",
        amount: "Amount",
        status: "Status",
      },
      record_source_labels: {
        b2b_direct: "B2B Direct",
        change_owner_auto_generated: "Change Owner Auto-Generated",
        not_in_b2b_snapshot: "External",
      },
      item: {
        resend_booking_confirmation: "Resend Booking Confirmation",
        booking_uid: "{brandName} Booking ID: {id}",
        cruise_line: "Cruise Line",
        ship: "Ship",
        sailing_date: "Sailing date",
        duration: "Duration",
        nights: "{night} Nights",
        itinerary: "Itinerary",
        embarkation: "Embarkation",
        disembarkation: "Disembarkation",
        booking_id: "Booking ID",
        reservation_date: "Reservation date",
        record_source: "Record source",
        contact: "Contact",
        tel: "Tel.",
        email: "Email:",
        room: "Room {index} Reservation Number: {reservationID}",
        get_booking_confirmation_and_payment: "Get booking confirmation",
        room_category: "Room category",
        room_category_detail: "{cabinGrade} - {description} Stateroom",
        room_number: "Room number",
        guest: "Guest {index}",
        date_of_birth: "Date of Birth",
        membership_no: "Membership no.",
        bedding_config: "Bedding Config",
        dining_time: "Dining Time",
        extra: "Extra",
        cruise_fare: "Cruise Fare",
        discount: "Discount",
        gratuities: "Gratuities",
        taxes: "Taxes",
        total: "Total",
        amend_booking: "Amend/Cancel",
        cancel_booking: "Cancel booking & Refund",
        logs_title: "Amendment / Cancellation logs",
        exchange_rate_title: "Committed Exchange Rate",
        payment_title: "Payments",
        go_to_my_booking: "Go to my booking",
        pay: "Pay",
        create_invoice: "Get an invoice and commit exchange rate",
        back: "Back",
        save_changes: "Save changes",
        overwrite: "Overwrite",
        cancel_overwrite: "Cancel Overwrite",
        logs: {
          headers: {
            res_id: "Res. ID",
            room_no: "Room No.",
            transaction_date: "Transaction date",
            status: "Status",
            agent_staff: "Agent staff",
            description: "Description",
            habo_user: "{brandName} user",
            habo_comment: "{brandName} Comments",
          },
        },
        exchange_rate: {
          headers: {
            commit_on: "Committed rate on",
            exchange_rate: "THB/USD",
            valid_till: "Valid till",
          },
        },
        payment: {
          contract_new: "New",
          headers: {
            paid: "Paid",
            res_id: "Res. ID",
            room_no: "Room No.",
            term: "Term",
            status: "Status",
            agent_staff: "Agent staff",
            due_date: "Due date",
            transaction_date: "Transaction date",
            payment_method: "Payment method",
            attachment: "Attachment",
            amount: "Amount",
            commission: "Commission",
            net_amount: "Net Amount",
            reject_reason: "Reject Reason",
          },
          total_paying_amount: "Total Net Amount",
          reject_reason_title: "Reason for Rejection",
          reject_reason_close: "Close",
          select_payment_method: "Select payment method",
          attachment: "Attachment",
          bank_transfer: "Bank Transfer",
          credit_card: "Credit Card",
          please_make_a_payment_to: "Please make a payment to",
          no_relationship_contact_staff:
            "No payment account is available for your organization yet. Please contact staff to set up the relationship.",
          fallback_recipient_notice: "Your parent hasn't set up a bank account yet. Payment will go to {name} instead.",
          beneficilary_bank: "Beneficilary bank",
          account_number: "Account number",
          account_name: "Account name",
          amount: "Net Amount",
          amount_text: "฿{amountTHB} (USD{amountUSD})",
          upload_pay_slip: "Upload pay slip",
          card_detial: "Card detials",
          card_number: "Card number",
          card_exp: "Exp. MM/YY",
          card_holder_name: "Card holder name",
          action: {
            approve: "Approve",
            reject: "Reject",
          },
          reject_dialog_title: "Reject Payment",
          reject_dialog_reason: "Reason (required)",
          deposit_required_for_balance_approval: "Cannot approve Balance amount because Deposit amount has not been approved.",
          otp: {
            dialog_title: "OTP Confirmation",
            resend: "Resend OTP",
            description: "This will affect for these reservation",
            effected_items: "#{reservationId} ({term})",
          },
          commit_bk: {
            title: "BK immediately?",
            body: "Would you like to change the selected booking status into “BK” at this moment?",
            bk_now: "BK NOW",
            leave_if_of: "Leave it OF",
          },
          confirm_go_back: "Are you sure you want to unsaved changes?",
          payment_request_success: "Payment request was successful",
          payment_confirm_success: "Payment confirmation was successful",
          save_changes_success: "Save changes was successful",
          cancel_payment_success: "Cancel payment was successful",
          reservation_return_status_success: "Reservation return status was successful",
        },
        invoice: {
          remark: "Remark",
          terms_and_condition: "Terms & Condition",
          download_invoice: "Download Invoice",
        },
        amendment: {
          title: "Please describe your amendment details below",
          description: "I would like to ...",
          submitted_title: "Amendment submitted",
          submitted_body: "Our staff will contact you to confirm the details  before proceed the amendment.",
          submitted_ok: "OK",
          request_details: "Request details",
          comment: "{brandName} comments",
          recall_confirmation: "Are you sure you want to recall this ticket?",
          reject_title: "Reason of rejection",
          reject_reason: "Your request was rejected because...",
          reject_confirmation: "Are you sure you want to reject this ticket?",
          approve_title: "Preview amendment",
          approve_confirmation: "Are you sure you want to approve this ticket?",
          approve_success: "This amendment was approved.",
          approve: {
            reservation_id: "Reservation ID:",
            sailing: "Sailing:",
            room_category: "Room category:",
            room_number: "Room number:",
            from: "FROM",
            to: "TO",
            guest: "Guest {index}:",
            date_of_birth: "Date of Birth: {date}",
            nationality: "Nationality: {nationality}",
            phone_number: "Phone Number: {phone_number}",
            membership_no: "Membership no.: {no}",
            bedding_config: "Bedding Config:",
            dining_time: "Dining Time:",
            fare_code: "Fare Code",
            extra_service: "Extra Service",
            deposit: "Deposit Due date",
            balance: "Balance Due date",
            full_payment: "Due date",
            comment: "Your comment for approving this reqeust...",
            recall_success: "The ticket was recalled",
            reject_success: "The ticket was rejected",
            approve_success: "The ticket was approved",
          },
          status: {
            submitted: "Submitted",
            recalled: "Recalled",
            rejected: "Rejected",
            completed: "Completed",
          },
          action: {
            recall: "Recall",
            reject: "Reject",
            approve: "Approve",
          },
        },
        cancel: {
          cancellation_title: "Cancellation submitted",
          cancellation_body:
            "Our staff will contact you to confirm your transaction before proceed the cancelation and refund.",
          cancellation_ok: "OK",
        },
        sync: {
          confirmation: "Are you sure to overwrite new changas update for all reservations?",
          success: "Successfully sync.",
        },
        resend: {
          confirmation: "Are you sure to resend the booking confirmation email?",
          success: "Successfully resend.",
        },
      },
      back: "Back",
      submit: "Submit",
      layered: {
        tabs: {
          pending: "Pending acknowledgment",
          inventory: "My inventory",
          tracking: "Network tracking",
        },
        empty: {
          pending: "No incoming transfers waiting for your approval.",
          inventory: "No held items.",
          tracking: "No items in your network.",
        },
        col: {
          reservation: "Reservation",
          payment_no: "Term",
          amount: "Amount",
          booking: "Booking",
          status: "Status",
          held_at: "Held at",
          submitter: "Submitter",
        },
        action: {
          approve: "Acknowledge receipt",
          approve_bundle: "Acknowledge bundle ({count})",
          reject: "Reject",
          reject_bundle: "Reject bundle ({count})",
          forward: "Forward selected",
          forward_short: "Forward",
          view_chain: "View payment chain",
        },
        bundle: {
          label: "Bundle of {count}",
          tooltip_title: "Submitted together in one transfer:",
          this_row: "this row",
        },
        slip_from: "Slip from",
        inventory_hint: "Select held items to forward upstream with your slip.",
        inventory_staff_hint:
          "These items are at the staff org. Use the existing payment workflow above to finalize with PHP.",
        dialog: {
          reject_title: "Reject transfer",
          reject_note: "Reason (required)",
          forward_title: "Forward to upstream",
          forward_summary: "Items to forward",
          payment_method: "Payment method",
          forward_note: "Note (optional)",
          upload_slip: "Your slip(s)",
          chain_title: "Transfer chain",
          held_at: "Currently at",
          slip_private: "Private — slip not shared",
          holder_private: "Forwarded upstream (private)",
          no_slip: "No slip uploaded",
        },
        status: {
          pending: "Pending",
          approved: "Approved",
          rejected: "Rejected",
          awaiting_parent_approval: "Awaiting acknowledgment",
          held: "Held",
          in_transit_to_php: "In transit to PHP",
          confirmed_core: "Confirmed",
          returned_to_submitter: "Returned to submitter",
        },
        toast: {
          approve_success: "Transfer acknowledged.",
          reject_success: "Transfer rejected.",
          forward_success: "Items forwarded.",
          generic_error: "Operation failed. Please try again.",
        },
        rollback: {
          button: "Clear history / Rollback",
          title: "Clear payment history & rollback",
          description:
            "Destructive action. Choose the scope per payment type. \"Roll back all\" wipes the entire B2B chain (items, transfers, slips) for that payment type and is only allowed when every reservation of that type is still Open in B2C. \"Clear rejected only\" removes rejected transfer history without touching active items.",
          loading: "Loading rollback preview...",
          no_data: "No payment data found for this booking.",
          column: {
            payment_type: "Payment type",
            b2c_state: "B2C state",
            b2b_state: "B2B chain",
            scope: "Action",
          },
          scope: {
            skip: "Skip",
            rejected_only: "Clear rejected history only",
            all: "Roll back all (delete entire chain)",
          },
          b2c_state_summary: "{open}/{total} reservation(s) still Open",
          b2c_finalized_label: "Already finalized",
          b2b_state_summary: "{items} item(s), {rejected} rejected transfer(s)",
          affected_label: "Items affected by your selection",
          action_label: {
            all: "Full rollback",
            rejected_only: "Remove rejected history",
          },
          confirm_uid_prompt: "Type this booking UID to confirm:",
          confirm_uid_hint: "Copy the value above (or click the copy icon) and paste it into the field below exactly.",
          confirm_uid_label: "Confirm booking UID",
          copy_uid: "Copy booking UID",
          copied: "Booking UID copied to clipboard.",
          submit: "Confirm rollback",
          success: "Rollback completed.",
        },
      },
    },
    org_hierarchy: {
      title: "Network Management",
      filter: {
        search: "Search by name, Tax ID, or Org ID",
        hierarchy: "Hierarchy",
        status: "Status",
        search_btn: "Search",
      },
      headers: {
        id: "ID",
        name: "Organization",
        tax_id: "Tax ID",
        status: "Status",
        parent: "Parent",
        children_count: "Children",
        commission_rate: "Comm. Rate",
        created_date: "Created",
      },
      actions: {
        view: "View Detail",
        assign: "Assign Children",
        detach: "Detach Children",
      },
      detail: {
        title: "Organization Detail",
        org_id: "Organization ID",
        name: "Organization Name",
        tax_id: "Tax ID",
        status: "Status",
        commission_rate: "Commission Rate",
        parent: "Parent Organization",
        no_parent: "No parent organization",
        children: "Child Organizations",
        no_children: "No child organizations",
      },
      assign: {
        title: "Assign Children",
        parent_org: "Parent Organization",
        search_children: "Search organizations to assign...",
        selected: "Selected organizations",
        no_results: "No organizations found",
        confirm: "Assign",
        success: "Children assigned successfully",
      },
      detach: {
        title: "Detach Children",
        parent_org: "Parent Organization",
        select_children: "Select children to detach",
        select_all: "Select All",
        confirm: "Detach",
        success: "Children detached successfully",
      },
      cancel: "Cancel",
    },
    commission: {
      title: "Commission",
      search: "Search",
      export: "Export",
      view_booking: "View Booking",
      filter: {
        from: "Departure Date From",
        to: "Departure Date To",
        keyword: "Keyword",
      },
      status: {
        processing: "Processing",
        settled: "Settled",
      },
      headers: {
        departure_date: "Departure Date",
        reservation_id: "Res. ID",
        reservation_date: "Res. Date",
        booking_value: "Total Amount",
        net_ccf: "Net CCF",
        net_amount: "Net Amount",
        receivable_commission: "Receivable Comm.",
        unrealized_commission: "Unrealized Comm.",
        agent_fully_paid_on: "Agent fully paid on",
        realized_commission_usd: "Realized Comm (USD)",
        realized_commission_thb: "Realized Comm (THB)",
        agent_user: "Agent user",
      },
    },
  },
  search: {
    box: {
      destination: "Destination",
      departure_date: "Departure Date",
      adults: "Adults",
      adult_options: "{amount} Adult",
      adults_options: "{amount} Adults",
      children: "Kids (1-12 years old)",
      kid_options: "{amount} Kid",
      children_options: "{amount} Kids",
      departure_port: "Departure Port",
      departure_port_option_all: "All Port",
      duration: {
        outer_label: "Duration",
        inner_label: "Duration",
        inner_label_suffix: "nights",
        all_option_label: "Any Duration",
      },
      price: {
        outer_label: "Price",
        inner_label: "Price under",
        all_option_label: "Any Price",
      },
      cruise_line: "Cruise Line",
      cruise_line_option_all: "All Cruise",
      ship_name: "Ship Name",
      ship_name_option_all: "All Ship",
      guest_age_over_55: "Guest age over 55",
      accessible_room: "Accessible Room",
      reset_all: "Reset All",
      search: "Search",
    },
    result: {
      headers: {
        departure_date: "Departure Date",
        itinerary: "Itinerary",
        cruise_line: "Cruise Line",
        ship_name: "Ship Name",
        duration: "Duration (Nights)",
        inside: "Inside",
        ocean_view: "Ocean View",
        balcony: "Balcony",
        suite: "Suite",
      },
      body: {
        see_itineraries: "See itinerary",
        select: "Select",
      },
    },
  },
  booking: {
    leave_message: "Do you really want to leave? Change you made may not be saved.",
    confirm_back_step: "Are you sure you want to go back step?",
    package_line_1: "{title} ({night} Nights)",
    package_line_2: "{sailDate} on {shipName}",
    package_line_3: "from {departurePort}",
    grand_total: "Grand Total",
    warning: {
      unavailable_title: "Selected room unavailable",
      unavailable_room: "Room{index}: #{id}",
      select_new_room: "Select new room",
      system_error_title: "System Error",
      please_start_over_the_cruise_search: "Please start over the cruise search",
      search_new_cruise: "Search new cruise",
      room_maintenance_title: "Temporarily Unavailable",
      room_maintenance_message: "This room type is temporarily unavailable due to maintenance. Please try again later.",
      room_maintenance_ack: "OK",
      guest_age_mismatch_title: "Guest age mismatch",
      guest_age_mismatch_body: "Room{roomIndex}: {message}",
      guest_age_mismatch_footer:
        "Change in guests age classification may cause changes in price, do you want to reclassify them as above?",
      adults: "{adults} Adults",
      adults_with_senior: "{adults} Adults, senior included",
      adults_kids: "{adults} Adults {kids} Kids",
      adults_kids_with_senior: "{adults} Adults {kids} Kids, senior included",
      recheck_birth_date: "Recheck birthdate",
      reclassify_all: "Reclassify all",
      guest_info_invalid_items: "Room{roomIndex}: #{roomNo} Guest {guestIndex}",
      guest_under_21_title: "One of guest age must be over 21 years",
      guest_under_18_title: "One of guest age must be over 18 years",
      is_under_21: "is under 21",
      is_under_18: "is under 18",
      guest_under_6_months_title: "Minimum guest age is 6 months",
      is_ineligible: "is ineligible",
      senior_over_55: "Minimum senior age is 55 years",
      classified_as_an_adult: "is classified as an adult",
      kids_under_12: "Maximum kids age is 12 years",
      classified_as_a_kids: "is classified a kid",
      assign_new_guest: "Assign new guest",
      select_new_extra: "Select new extra",
    },
    breadcrumbs: {
      search: "Search",
      room_location: "Room Location",
      extra: "Extra",
      guest_details: "Guest Details",
      reserve: "Reserve",
    },
    price_break_down: {
      room: "Room {index}",
      room_cabin: "Room {index} #{cabinNo}",
      adults_options: "{amount} Adults",
      children_options: "{amount} Kids",
      senior_include: ", Senior include",
      nights: "{night} nights",
      from: "from {departurePort}",
      guest: "Guest {index}",
      cruise_fare: "Cruise Fare",
      ccf: "CCF",
      nccf: "NonCCF",
      discount: "Discount",
      tax: "Tax & Fee",
      gratuities: "Gratuities",
      total: "Total",
      deposit: "Deposit",
      obc: "OBC",
      commission: "Commission",
    },
    location: {
      room: "Room",
      total: "Total",
      price_pax: "Price/Pax",
      gty_message: "You will get the best available stateroom based on availability, assigned prior to sailing.",
      new_room: "New Room #{index}",
      edit_room: "Edit Room #{index}",
      adults: "Adults",
      adult_options: "{amount} Adult",
      adults_options: "{amount} Adults",
      kids: "Kids",
      children: "Kids (1 - 12 years old)",
      kid_age: "Kid age",
      kid_options: "{amount} Kid",
      children_options: "{amount} Kids",
      room_capacity: "Max {guest} guests",
      room_type: "Room Type",
      accessible_room: "Accessible Room",
      gty_categories: "{roomType} - {description}",
      all_categories: "All {roomType} Stateroom",
      confirm_remove_cabin: "Are you sure you want to remove this room?",
      add_room: "Add Room {index}",
      guest_age_over_55: "Guest age over 55",
      senior_include: ", Senior include",
      confirm_back_step: "Are you sure you want to go back step?",
      dimension: "Dimension",
      obstruct: "Obstruct",
      theme: "Theme",
      unobstructed_view: "Unobstructed view",
    },
    extra: {
      room: "Room",
      per_room: "per room",
      confirm_remove_cabin: "Are you sure you want to remove this room?",
      max_capacity_title: "Number of selected guest exceed cabin's maximum capacity",
      select_new_room: "Select new room",
      get_quotation: "Get Quotation",
      edit_room: "Edit Room #{index}",
      adults: "Adults",
      adult_options: "{amount} Adult",
      adults_options: "{amount} Adults",
      kids: "Kids",
      children: "Kids (1 - 12 years old)",
      kid_options: "{amount} Kid",
      children_options: "{amount} Kids",
      room_capacity: "Max {guest} guests for #{cabinNo}",
      guest_age_over_55: "Guest age over 55",
      quotation: {
        remark: "Remark",
        terms_and_condition: "Terms & Condition",
        save_as_default: "Save as default",
        send_to: "Send to",
        add_email: "Add email",
        copy_link: "Copy link",
        download_quotation: "Download Quotation",
      },
      change_total_guest: {
        title: "Change in total number of guests",
        body: "The new number of guests does not fit the previously selected room category.",
        confirm: "Do you want to select new room category?",
        find_new_room: "Yes, find new room category",
        cancel_change: "No, cancel the change in number of guests",
      },
      suspended: {
        title: "Your account is suspended",
        body: "You have reached the maximum number of reserved cabin. To proceed futher reservation, please contact {brandName} admin.",
      },
      ok: "OK",
      confirm_back_step: "Are you sure you want to go back step?",
    },
    guest: {
      guest_index: "Guest {index}",
      title: "Title",
      firstname: "First name",
      lastname: "Last name",
      email: "Email",
      tel: "Tel",
      date_of_birth: "Date of Birth",
      nationality: "Nationality",
      membership_no: "Membership no.",
      address: "Address",
      room_title: "Room {index} : {title} No.{cabinNo}",
      bedding_config: "Bedding Config",
      dining_time: "Dining time",
      optional: "Optional",
      confirm_back_step: "Are you sure you want to go back step?",
    },
    reserve: {
      title: "To confirm this booking, please hit the RESERVE button below",
      cruise_line: "Cruise Line",
      ship: "Ship",
      sailing_date: "Sailing date",
      duration: "Duration",
      nights: "{night} Nights",
      itinerary: "Itinerary",
      embarkation: "Embarkation",
      disembarkation: "Disembarkation",
      booking_id: "Booking ID",
      reservation_date: "Reservation date",
      contact: "Contact",
      tel: "Tel.",
      email: "Email:",
      room: "Room {index}",
      room_category: "Room category",
      room_category_detail: "{cabinGrade} - {description} Stateroom",
      room_number: "Room number",
      guest: "Guest {index}",
      date_of_birth: "Date of Birth",
      membership_no: "Membership no.",
      bedding_config: "Bedding Config",
      dining_time: "Dining Time",
      extra: "Extra",
      cruise_fare: "Cruise Fare",
      discount: "Discount",
      gratuities: "Gratuities",
      taxes: "Taxes",
      total: "Total",
      reserve: "Reserve",
      confirm_back_step: "Are you sure you want to go back step?",
      confirm_reserve: "Are you sure you want to reserve this booking?",
    },
    reset: "Reset",
    apply: "Apply",
    back: "Back",
    continue: "Continue",
  },
  common: {
    cancel: "Cancel",
    close: "Close",
    confirm: "Confirm",
    save: "Save",
    submit: "Submit",
    ok: "OK",
  },
};
